var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-container',[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('Bar',{attrs:{"id":"dashboard-widget-graph","options":_vm.chartOptions,"data":_vm.chartData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }